import React, { useCallback, useEffect, useState } from "react";
import {
  EditRegular,
  Building16Filled,
  EyeFilled,
} from "@fluentui/react-icons";
import {
  TableBody,
  TableCell,
  TableRow,
  Table,
  TableHeader,
  TableHeaderCell,
  TableCellLayout,
  Button,
  useArrowNavigationGroup,
  useRestoreFocusTarget,
} from "@fluentui/react-components";
import { useAppToast } from "hooks/Toast/useAppToast";
import { useBoolean, useId } from "@fluentui/react-hooks";
import { ProspectionRecord, ProspectionTableState } from "../index.types";
import moment from "moment";
import { ProspectionDrawer } from "../Drawer";
import { useGetBasicCnpjInfo } from "hooks/Prospection/useProspectionSearch";
import { useQueryClient } from "@tanstack/react-query";
import { TableRowActions } from "./actions";

const columns = [
  { columnKey: "cnpj", label: "CNPJ" },
  { columnKey: "name", label: "Razao Social" },
  // { columnKey: "createdAt", label: "Criado" },
  // { columnKey: "updateOn", label: "Atualizado" },
];

const lastUpdated = (createdAt, updateAt) => {
  if (updateAt) {
    var rightNow = moment().isDST() ? moment().subtract(1, "hour") : moment();
    const diff = rightNow.diff(updateAt, "hours", true);
    return `${diff.toFixed(2)} horas`;
  }
  return "";
};

export const ProspectionTable = (state: ProspectionTableState) => {
  const keyboardNavAttr = useArrowNavigationGroup({ axis: "grid" });
  const { styles, prospectList } = state;
  const [selectedProspect, setSelectProspect] =
    useState<ProspectionRecord>(null);

  const [
    isDrawerOpen,
    { setFalse: setIsDrawerOpenFalse, setTrue: setIsDrawerOpenTrue },
  ] = useBoolean(false);

  return (
    <div>
      <Table {...keyboardNavAttr} role="grid" style={{ minWidth: "600px" }}>
        <TableHeader>
          <TableRow>
            {columns.map((column) => (
              <TableHeaderCell key={column.columnKey}>
                {column.label}
              </TableHeaderCell>
            ))}
            <TableHeaderCell key="Criado">Criado</TableHeaderCell>
            <TableHeaderCell style={{ width: "70px" }} key="Atualizado">
              Atualizado
            </TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {prospectList.map((company: ProspectionRecord) => (
            <TableRow key={company.cnpj}>
              <TableCell tabIndex={0} role="gridcell">
                <TableCellLayout media={<Building16Filled />}>
                  {company.cnpj}
                </TableCellLayout>
              </TableCell>
              <TableCell tabIndex={0} role="gridcell">
                <TableCellLayout>{company.nome}</TableCellLayout>
              </TableCell>
              <TableCell tabIndex={0} role="gridcell">
                <TableCellLayout>
                  {moment(company.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                </TableCellLayout>
              </TableCell>
              <TableCell tabIndex={0} role="gridcell">
                <TableCellLayout>
                  {lastUpdated(company.createdAt, company.updateOn)}
                </TableCellLayout>
              </TableCell>
              <TableCell role="gridcell">
                <TableRowActions
                  record={company}
                  setIsDrawerOpenTrue={setIsDrawerOpenTrue}
                  setSelectProspect={setSelectProspect}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {selectedProspect && (
        <ProspectionDrawer
          selectedProspect={selectedProspect}
          isOpen={isDrawerOpen}
          setIsOpen={setIsDrawerOpenTrue}
          setIsFalse={setIsDrawerOpenFalse}
        />
      )}
    </div>
  );
};
